import type { CoreTypes } from '../';
import _exceptions from './exceptions';
import _periods from './periods';
import _locations from './locations';
import _teachers from './teachers';
import _groups from './groups';
import _persons from './persons';
import _courses from './courses';
import _events from './events';
import _lockedTimes from './locked-times';
import _rootIntervals from './root-intervals';
import _settings from './settings';
import _division from './division';
import _syllabuses from './syllabuses';
import _configurations from './configurations';
import _linkedEventsSets from './linked-events-sets';
import type { InternalIdKey } from '../types/common';
import type { InternalKeysOmitted } from './util';
import type { BaseOptions } from '../../common/types';

export namespace OutTypes {
  export type division        = Omit<InternalKeysOmitted<CoreTypes.Serialized.Division>, InternalIdKey>;
  export type settings        = InternalKeysOmitted<CoreTypes.Serialized.Settings>;
  export type configuration   = InternalKeysOmitted<CoreTypes.Serialized.Configuration>;
  export type exception       = InternalKeysOmitted<CoreTypes.Serialized.Exception>;
  export type period          = InternalKeysOmitted<CoreTypes.Serialized.Period>;
  export type location        = InternalKeysOmitted<CoreTypes.Serialized.Location>;
  export type teacher         = InternalKeysOmitted<CoreTypes.Serialized.Teacher>;
  export type group           = InternalKeysOmitted<CoreTypes.Serialized.Group>;
  export type person          = InternalKeysOmitted<CoreTypes.Serialized.Person>;
  export type course          = InternalKeysOmitted<CoreTypes.Serialized.Course>;
  export type event           = InternalKeysOmitted<CoreTypes.Serialized.Event>;
  export type lockedTime      = InternalKeysOmitted<CoreTypes.Serialized.LockedTime>;
  export type rootInterval    = InternalKeysOmitted<CoreTypes.Serialized.RootInterval>;
  export type syllabus        = InternalKeysOmitted<CoreTypes.Serialized.Syllabus>;
  export type linkedEventsSet = InternalKeysOmitted<CoreTypes.Serialized.LinkedEventsSet>;
}

type Out = {
  division?:         OutTypes.division;
  settings?:         OutTypes.settings;
  exceptions?:       OutTypes.exception[];
  periods?:          OutTypes.period[];
  locations?:        OutTypes.location[];
  teachers?:         OutTypes.teacher[];
  groups?:           OutTypes.group[];
  persons?:          OutTypes.person[];
  courses?:          OutTypes.course[];
  events?:           OutTypes.event[];
  lockedTimes?:      OutTypes.lockedTime[];
  rootIntervals?:    OutTypes.rootInterval[];
  syllabuses?:       OutTypes.syllabus[];
  configurations?:   OutTypes.configuration[];
  linkedEventsSets?: OutTypes.linkedEventsSet[];
  meta:              { structure: string };
};

export default function (
  schedule: Partial<CoreTypes.Mixed.Schedule>
): Out {
  const options: BaseOptions = {};

  return {
    meta: { structure: 'RS/core-2.0.0' },
    ...schedule.divisions        && { division:         _division        (schedule.divisions,        options) },
    ...schedule.settings         && { settings:         _settings        (schedule.settings,         options) },
    ...schedule.exceptions       && { exceptions:       _exceptions      (schedule.exceptions,       options) },
    ...schedule.periods          && { periods:          _periods         (schedule.periods,          options) },
    ...schedule.locations        && { locations:        _locations       (schedule.locations,        options) },
    ...schedule.teachers         && { teachers:         _teachers        (schedule.teachers,         options) },
    ...schedule.groups           && { groups:           _groups          (schedule.groups,           options) },
    ...schedule.persons          && { persons:          _persons         (schedule.persons,          options) },
    ...schedule.courses          && { courses:          _courses         (schedule.courses,          options) },
    ...schedule.events           && { events:           _events          (schedule.events,           options) },
    ...schedule.lockedTimes      && { lockedTimes:      _lockedTimes     (schedule.lockedTimes,      options) },
    ...schedule.rootIntervals    && { rootIntervals:    _rootIntervals   (schedule.rootIntervals,    options) },
    ...schedule.syllabuses       && { syllabuses:       _syllabuses      (schedule.syllabuses,       options) },
    ...schedule.configurations   && { configurations:   _configurations  (schedule.configurations,   options) },
    ...schedule.linkedEventsSets && { linkedEventsSets: _linkedEventsSets(schedule.linkedEventsSets, options) },
  };
}